const jsonSchemaRecipe = ({
    title,
    writer_info: {
        nickname,
    },
    thumbnail,
    recipe_description,
    cook_time,
    prep_time,
    method,
    recipe_ingredients,
}) => {
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('id', 'recipe-ld-json');

    script.innerHTML = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Recipe',
        name: title,
        image: [thumbnail.url],
        author: {
            '@type': 'Person',
            name: nickname,
        },
        description: recipe_description,
        prepTime: prep_time[0].data,
        cookTime: cook_time[0].data,
        recipeIngredient: recipe_ingredients.map(({ ingredient, measure }) => `${measure} ${ingredient}`),
        recipeInstructions: method.map(({ step }) => ({ '@type': 'HowToStep', text: step })),
    });

    document.head.appendChild(script);
};

const jsonSchemaRecipeRemove = () => {
    const recipeScript = document.getElementById('recipe-ld-json');

    if (recipeScript) {
        recipeScript.remove();
    }
};

export {
    jsonSchemaRecipe,
    jsonSchemaRecipeRemove,
}
